// ftrs
export const HANDICAP_BETTING = "Handicap Betting";
export const MATCH_WINNER = "Match Winner";
export const OVER_UNDER_TOTALS = "Over/Under Totals";
export const FULL_TIME_RESULT = "Full-Time Result";

export const MAIN_MARKETS = [HANDICAP_BETTING, MATCH_WINNER, OVER_UNDER_TOTALS];

// lists
export const COMPETITION_WINNER = "Competition Winner";
export const WIN_AND_EACH_WAY = "Win & Each Way";
export const FIRS_ROUND_LEADER = "First Round Leader";
export const RACE_WINNER = "Race Winner";
export const TOP_BATSMAN = "Top Batsman";
export const FIRST_TEAM_TO_SCORE = "First Team To Score";
export const MOST_RUNS = "Most Runs";
export const TRYSCORER = "Tryscorer";
export const TOP_BOWLER = "Top Bowler";
export const FIRST_GOALSCORER = "First Goalscorer";

export const LISTS = [
  COMPETITION_WINNER,
  WIN_AND_EACH_WAY,
  FIRS_ROUND_LEADER,
  RACE_WINNER,
  TOP_BATSMAN,
  FIRST_TEAM_TO_SCORE,
  MOST_RUNS,
  TRYSCORER,
  TOP_BOWLER,
  FIRST_GOALSCORER
];

// promos
export const DOUBLE_RESULT = "Double Result";
export const BET_WITHOUT = "Bet Without";
export const PROMO = "Promo";
export const ENHANCED_ACCUMULATOR = "Enhanced Accumulator";
export const COMBI = "Combi";
export const TEAM_SPECIAL = "Team Special";
export const INSURE_BET = "Insure Bet";
export const PRICE_BOOST = "Price Boost";

export const PROMOS = [
  DOUBLE_RESULT,
  BET_WITHOUT,
  PROMO,
  ENHANCED_ACCUMULATOR,
  COMBI,
  TEAM_SPECIAL,
  INSURE_BET,
  PRICE_BOOST
];

export const FTR_GROUP = "ftr";
export const WDW_GROUP = "wdw";
export const WW_GROUP = "ww";
export const LIST_GROUP = "list";
export const PROMO_GROUP = "promo";
export const MAIN_MARKET_GROUP = "mainMarket";
export const INSIGHT_GROUP = "insight";
